<template>
  <v-container id="Auditoria" fluid>
    <v-row>
      <v-col col="12" class="text-center mb-8">
        <h2 class="font-heading text-h3 mb-4">
          Impuestos
        </h2>
        <v-divider class="mx-auto bg-brand-orange" style="max-width: 100px; height: 4px;"></v-divider>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="6">
        <v-img
          src="https://www.sydle.com/blog/assets/post/auditoria-interna-649c70daaabaad5335fb1bb6/audit-icon.jpg"
          alt="Auditoria"
          class="rounded-lg"
          cover
          height="400"
        ></v-img>
      </v-col>
      <v-col cols="12" md="6">
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Nuestro servicio impositivo no solo se basa en el cumplimiento en tiempo y forma
          de todas las obligaciones fiscales sino también en la planificación fiscal,
          determinando anticipadamente la incidencia impositiva en los resultados de la empresa
          y aprovechando los beneficios fiscales existentes.
        </p>
        <v-expansion-panels variant="accordion">
          <v-expansion-panel
            v-for="(panel, i) in panels"
            :key="i"
            :text="panel.text"
            :title="panel.title"
          ></v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      panels: [
        {
          title: 'Liquidaciones Impositivas mensuales y anuales de la empresa y los socios',
          text: ''
        },
        {
          title: 'Auditoria Fiscal',
          text: "Aquellas empresas que liquidan sus impuestos internamente, con su propio personal, \
          requieren no solo el asesoramiento de un estudio externo sinó también una revisión periódica \
          de las normas que aplican y la metodología de liquidación. Nuestro servicio se basa en revisar \
          periódicamente que las liquidaciones impositivas no presenten inconsistencias y se adecúen a la normativa vigente."
        },
        {
          title: 'Tax Planning',
          text: "La planificación fiscal es de vital importancia tanto para evaluar un nuevo negocio como para \
          mejorar negocios en marcha. Es necesario presupuestar correctamente la incidencia fiscal en el negocio \
          y sobre todo anticipar los impuestos a pagar. Nuestro servicio comprende una correcta planificación de las \
          incidencias impositivas, previendo con 5 meses de anticipación cual será la carga impositiva en el Impuesto \
          Anual de Ganancias y Bienes Personales, con una antelación tal que permite tomar decisiones fiscales a tiempo."
        },
        {
          title: 'Informe Anual de Situación Fiscal',
          text: "Dada la gran cantidad de impuestos que graban tanto a las empresas como a sus socios, es necesario realizar \
          un cierre anual a fin de evaluar la correcta cancelación de los mismos. Nuestro servicio comprende suministrar un \
          Informe Anual de la sociedad y sus socios, informando sobre la situación en todos los impuestos, si fueron cancelados \
          o se encuentran pendiente de pago. Abarca Autónomos, Bienes Personales, Ganancias, Anticipos, IVA, Rentas, etc. "
        },
        {
          title: 'Beneficios Fiscales',
          text: "Dado lo dinámico que es el sistema tributario argentino, permanentemente surgen nuevos beneficios fiscales, tanto \
          para empresas como para personas físicas. Estos beneficios van desde desgravaciones impositivas, diferimientos, créditos no \
          reembolsables, merma de alícuotas, etc. Nuestro servicio comprende analizar permanentemente todos los beneficios fiscales \
          vigentes y evaluar a que clientes de nuestro estudio puede beneficiarse. "
        },
        {
          title: 'Atención de Inspecciones',
          text: "Al contar con mejores sistemas y tecnología, el control de la información por parte del ente recaudador es cada vez mayor. \
          Con esta herramienta, le permite cruzar y conciliar información de distintas fuentes, permitiéndole detectar inconsistencias con \
          mucha facilidad. Ante estas inconsistencias, se realizan inspecciones sobre la empresa o sus socios. Nuestro servicio comprende la \
          atención de estas inspecciones, recibiendo en nuestras oficinas a los inspectores y cumpliendo con todo lo requerido para evitar un \
          ajuste fiscal por inspección."
        },
        {
          title: 'Asesoramiento Fiscal y Agenda Vencimientos',
          text: "Nuestros clientes cuentan con la posibilidad de realizar consultas permanentemente, via telefónica o via web, \
          con respuesta inmediata en temas comunes, y una respuesta en 24 horas en temas mas complejos que requieren mayor \
          análisis. Además, se les informa via mail, por nota y por mensaje de texto a su celular de sus próximos vencimientos."
        }
      ]
    }
  }
}
</script>
<style lang="">
    
</style>